import { useEffect } from 'react'
import { collection, onSnapshot } from 'firebase/firestore'
import { map } from 'lodash'
import useStore, { LocalConfig } from '../store/useStore'
import ConfigList from '../types/ConfigList'
import { getEffectiveServices } from '../utils/firebaseServiceContext'

const defaultMeta = {
  dayOfMonthLimit: 15,
  omitSundays: [],
  numBootcamps: 0,
  bootcampNames: [],
  numEssentialsCourses: 0,
  essentialsCoursesNames: [],
}

const useFetchConfig = () => {
  const identityStatus = useStore((state) => state.identityStatus)
  useEffect(() => {
    if (!['primary', 'impersonating'].includes(identityStatus)) return
    const unsubscribe = onSnapshot(
      collection(getEffectiveServices().firestore, 'config'),
      (snap) => {
        const config: LocalConfig = {}
        let hasMeta = false

        snap.forEach((doc) => {
          if (doc.id === 'stages') {
            useStore.setState({ stages: doc.data().value })
          } else if (doc.id === 'meta') {
            hasMeta = true
            useStore.setState({ meta: doc.data() as any })
          } else {
            const data = doc.data() as ConfigList
            config[doc.id] = {}

            // add items only if they are not archived
            map(data.value, (value, key) => {
              if (!data.archivedIds?.includes(key)) {
                config[doc.id][key] = value
              }
            })
          }
        })

        useStore.setState({
          config,
          ...(!hasMeta ? { meta: defaultMeta } : {}),
        })
      }
    )

    return () => unsubscribe()
  }, [identityStatus])
}

export default useFetchConfig
